import { render, staticRenderFns } from "./GerenciaHeaders.vue?vue&type=template&id=78da2427&scoped=true"
import script from "./GerenciaHeaders.vue?vue&type=script&lang=js"
export * from "./GerenciaHeaders.vue?vue&type=script&lang=js"
import style0 from "./GerenciaHeaders.vue?vue&type=style&index=0&id=78da2427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da2427",
  null
  
)

export default component.exports